import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyDonateBar from "./StickyDonateBar";

export default function Layout() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const isDonate = pathname === "/donate";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // Meta Pixel — fire PageView on every SPA route change
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [pathname]);

  return (
    <div className="relative min-h-screen flex flex-col" data-testid="app-layout">
      <Navbar />
      <main className={`relative z-10 flex-1 ${isHome || isDonate ? "" : "pt-20"}`}>
        <Outlet />
      </main>
      <Footer />
      <StickyDonateBar />
    </div>
  );
}
